import { render, staticRenderFns } from "./RemoveSlots.vue?vue&type=template&id=9250c4e2&scoped=true&"
import script from "./RemoveSlots.vue?vue&type=script&lang=js&"
export * from "./RemoveSlots.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSlots.vue?vue&type=style&index=0&id=9250c4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9250c4e2",
  null
  
)

export default component.exports